var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":_vm.label,"outlined":_vm.outlined,"items":_vm.items,"item-text":"name","item-value":"name","clearable":_vm.clearable},on:{"change":_vm.onChange},model:{value:(_vm.selectedLeadSource),callback:function ($$v) {_vm.selectedLeadSource=$$v},expression:"selectedLeadSource"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd172d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/LeadSourceListSelect.vue
// module id = null
// module chunks = 